import React from 'react';

const InnovationFestivalAdvertorialBanner = () => (
  <div className="innovation-festival-advertorial-banner">
    <div className="innovation-festival-advertorial-banner--container">
      <div className="innovation-festival-advertorial-banner--logo">
        <img
          alt="Innovation Festival | FastCo Works Logo"
          src="//images.fastcompany.net/image/upload/v1663944292/fcweb/FCIF-Logo-FCWorks-2022_ntshrg.svg"
        />
      </div>

      <div className="innovation-festival-advertorial-banner--label">
        sponsored content
      </div>
    </div>
  </div>
);

export default InnovationFestivalAdvertorialBanner;
